import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 80vh;
  text-align: center;
  margin: 2em;

  @media (max-width: 900px) {
    display: flex;
    flex-direction: column;
    height: auto;
    padding: 3em 0;
    margin: 0;
  }
`;

export const AboutContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: 900px) {
    padding: 10px;
    margin: 10px;
  }
`;

export const AboutHeading = styled.p`
  text-transform: uppercase;
  font-size: 2em;
`;

export const AboutText = styled.p``;

export const Image = styled.img`
  height: 300px;
  width: 300px;
  border-radius: 50%;
  object-fit: cover;
  transition: opacity 0.3s;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s;
`;

export const ImageText = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  text-align: center;
  opacity: 0;
  transition: opacity 0.3s;
`;

export const ImageContainer = styled.div`
  position: relative;
  &:hover ${ImageOverlay} {
    opacity: 1;
  }
  &:hover ${ImageText} {
    opacity: 1;
  }
`;
